import * as React from "react";
import Box from "@mui/material/Box";
import LanguageIcon from "@mui/icons-material/Language";
import {
  Alert,
  Button,
  Card,
  CardActions,
  CardContent,
  CardMedia,
  Checkbox,
  CircularProgress,
  Container,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  FormControl,
  Grid,
  IconButton,
  InputAdornment,
  InputLabel,
  ListItemText,
  Menu,
  MenuItem,
  OutlinedInput,
  Select,
  SelectChangeEvent,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from "@mui/material";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import { ShippingContextType, ShipProfileContext } from "./ShippingProfile";
import {
  useGetCountriesQuery,
  useAddDeliveryProfileMutation,
} from "../../../redux/reducer/features/Shipping/shippingSlice";
import { Country, Province } from "../../../models/features/Shipping/Shipping";
import { number } from "yup";
import PageLoader from "../../app/PageLoader";

interface ProfileNameProps {
  handleBack: any;
}
const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

const carriers = [
  {
    id: 65075675351,
    name: "dhl_express",
    active: true,
    service_discovery: true,
    carrier_service_type: "legacy",
    admin_graphql_api_id: "gid://shopify/DeliveryCarrierService/65075675351",
  },
  {
    id: 65075708119,
    name: "ups_shipping",
    active: true,
    service_discovery: true,
    carrier_service_type: "legacy",
    admin_graphql_api_id: "gid://shopify/DeliveryCarrierService/65075708119",
  },
  {
    id: 65075642583,
    name: "usps",
    active: true,
    service_discovery: true,
    carrier_service_type: "legacy",
    admin_graphql_api_id: "gid://shopify/DeliveryCarrierService/65075642583",
  },
];
const DHLServices = [
  {
    service: "Worldwide",
    isSelected: false,
  },
];
const UPSServices = [
  {
    service: "UPS 2nd Day Air A.M.® (commercial addresses only)",
    isSelected: false,
  },
  { service: "UPS 2nd Day Air®", isSelected: false },
  { service: "UPS 3 Day Select®", isSelected: false },
  { service: "UPS Next Day Air Saver®", isSelected: false },
  { service: "UPS Next Day Air®", isSelected: false },
  { service: "UPS Next Day Air® Early", isSelected: false },
  { service: "UPS Worldwide Expedited®", isSelected: false },
  { service: "UPS Worldwide Express Plus®", isSelected: false },
  { service: "UPS Worldwide Express®", isSelected: false },
  { service: "UPS Worldwide Saver®", isSelected: false },
  { service: "UPS® Ground", isSelected: false },
  { service: "UPS® Standard", isSelected: false },
];

const USPSServices = [
  {
    service: "First Class Package International",
    isSelected: false,
  },
  { service: "Priority Mail Express International", isSelected: false },
  { service: "Priority Mail International", isSelected: false },
];
const ShippingTo: React.FunctionComponent<ProfileNameProps> = ({
  handleBack,
}) => {
  const { profile, setProfile } = React.useContext(
    ShipProfileContext
  ) as ShippingContextType;

  React.useEffect(() => {
    console.log("Context Data", profile);
  }, [profile]);

  const { data, isLoading } = useGetCountriesQuery();
  const [openZone, setOpenZone] = React.useState(false);
  const [openRate, setOpenRate] = React.useState(false);
  const [zoneName, setZoneName] = React.useState("");
  const [searchQuery, setSearchQuery] = React.useState("");
  const [percentage, setPercentage] = React.useState("0");
  const [flatAmount, setFlatAmount] = React.useState("0");
  const [zones, setZones] = React.useState<any[]>([]);
  const [countries, setCountries] = React.useState<Country[]>([]);
  const [carrier, setCarrier] = React.useState("");
  const [services, setServices] = React.useState<any[]>([]);
  const [selectedZone, setSelectedZone] = React.useState("");
  const [errorMessage, setErrorMessage] = React.useState("");
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const [addProfileMutation, addProfileMutationResult] =
    useAddDeliveryProfileMutation();

  const handleClose = () => {
    setOpenZone(false);
    setOpenRate(false);
    setAnchorEl(null);
  };
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleDeleteRate = (carrierName: any) => {
    setZones(
      zones.map((item) =>
        item.name === selectedZone
          ? {
              ...item,
              methodDefinitionsToCreate: item.methodDefinitionsToCreate.filter(
                (method: any) => method.name != carrierName
              ),
            }
          : item
      )
    );
  };

  const handleSetCarrier = (value: any) => {
    setCarrier(value);
    if (value === "dhl_express") {
      setServices(DHLServices);
    } else if (value === "usps") {
      setServices(USPSServices);
    } else if (value === "ups_shipping") {
      setServices(UPSServices);
    }
  };

  const handleZoneSubmit = () => {
    setZones([
      ...zones,

      {
        name: zoneName,
        countries: countries
          .filter((item) => item.isSelected)
          .map((c) => {
            return {
              code: c.code,
              provinces: c.provinces?.map((p: any) => {
                return { code: p.code };
              }),
              restOfWorld: false,
            };
          }),
        methodDefinitionsToCreate: [],
      },
    ]);
    setOpenZone(false);
    setZoneName("");
  };

  React.useEffect(() => {
    if (data) {
      console.log("countries", data);
      setCountries(data.entityList ?? []);
    }
  }, [data]);
  const handleRateSubmit = () => {
    setZones(
      zones.map((item) =>
        item.name === selectedZone
          ? {
              ...item,
              methodDefinitionsToCreate: [
                ...item.methodDefinitionsToCreate,
                {
                  name: carrier,
                  description: null,
                  active: true,
                  participant: {
                    adaptToNewServices: false,
                    carrierServiceId:
                      "gid://shopify/DeliveryCarrierService/" +
                      carriers.find((c) => c.name === carrier)?.id,
                    fixedFee: {
                      amount: flatAmount === "" ? "0" : flatAmount,
                      currencyCode: "USD",
                    },
                    participantServices: services
                      .filter((item) => item.isSelected == true)
                      .map((s) => ({
                        active: true,
                        name: s.service,
                      })),
                    percentageOfRateFee: parseInt(percentage),
                  },
                },
              ],
            }
          : item
      )
    );
    setCarrier("");
    setOpenRate(false);
    setFlatAmount("0");
    setPercentage("0");
  };

  const handleFinish = () => {
    // setProfile({
    //   ...profile,
    //   variantsToAssociate: profile.variantsToAssociate?.map(
    //     (prod: any) => "gid://shopify/ProductVariant/" + prod
    //   ),
    //   locationGroupsToCreate: profile?.locationGroupsToCreate
    //     ? [
    //         {
    //           zonesToCreate: zones,
    //           locations: profile.locationGroupsToCreate[0].locations.map(
    //             (loc: any) => "gid://shopify/Location/" + loc
    //           ),
    //         },
    //       ]
    //     : [
    //         {
    //           zonesToCreate: zones,
    //           locations: [],
    //         },
    //       ],
    // });
    addProfileMutation({
      data: {
        profile: {
          ...profile,
          variantsToAssociate: profile.variantsToAssociate?.map(
            (prod: any) => "gid://shopify/ProductVariant/" + prod
          ),
          locationGroupsToCreate: profile?.locationGroupsToCreate
            ? [
                {
                  zonesToCreate: zones,
                  locations: profile.locationGroupsToCreate[0].locations.map(
                    (loc: any) => "gid://shopify/Location/" + loc
                  ),
                },
              ]
            : [
                {
                  zonesToCreate: zones,
                  locations: [],
                },
              ],
        },
      },
    });
  };

  const onServiceClick = (value: any) => {
    setServices(
      services.map((item) =>
        item.service === value
          ? {
              ...item,
              isSelected: !item.isSelected,
            }
          : item
      )
    );
  };

  const onCountryClick = (country: Country, index: number) => {
    setCountries(
      countries.map((item) =>
        item.id === country.id
          ? {
              ...item,
              isSelected: !item.isSelected,
              provinces: item.provinces?.map((pro) => ({
                ...pro,
                isSelected: !item.isSelected,
              })),
            }
          : item
      )
    );
  };
  const onProvinceClick = (province: Province) => {
    setCountries(
      countries.map((item) =>
        item.id === province.countryId
          ? {
              ...item,
              isSelected: province.isSelected ? item.isSelected : true,
              provinces: item.provinces?.map((pro) =>
                pro.id === province.id
                  ? {
                      ...pro,
                      isSelected: !province.isSelected,
                    }
                  : pro
              ),
            }
          : item
      )
    );
  };
  React.useEffect(() => {
    if (addProfileMutationResult.data) {
      if (addProfileMutationResult.data.entity !== "") {
        window.location.href = "/ShippingProfile";
      } else {
        setErrorMessage("sorry! We could not add your profile.");
      }
    }
  }, [addProfileMutationResult]);

  return (
    <React.Fragment>
      <Container maxWidth="lg">
        <>
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              pt: 2,
              pb: 2,

              justifyContent: "right",
            }}
          >
            <Button
              onClick={() => {
                setOpenZone(true);
              }}
              size="small"
            >
              Create Shipping Zone
            </Button>
          </Box>
          <Card>
            <CardContent sx={{ height: "55vh", overflow: "auto" }}>
              <>
                {zones.length !== 0 ? (
                  zones.map((item) => {
                    return (
                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "row",
                          justifyContent: "center",
                        }}
                      >
                        <Card sx={{ width: 750, minHeight: "30vh", mt: 3 }}>
                          <CardContent>
                            <Typography
                              gutterBottom
                              variant="h5"
                              component="div"
                            >
                              <LanguageIcon /> {item.name}
                            </Typography>
                            <Typography variant="body2" color="text.secondary">
                              {item.countries?.map(
                                (country: any) => country.code + " ,"
                              )}
                            </Typography>
                            <br />

                            {item?.methodDefinitionsToCreate.length > 0 ? (
                              <TableContainer>
                                <Table>
                                  <TableHead>
                                    <TableRow>
                                      <TableCell>Carrier Name</TableCell>
                                      <TableCell align="center">
                                        Handling Fee
                                      </TableCell>
                                      <TableCell align="center">
                                        Transit time
                                      </TableCell>
                                      <TableCell align="right" />
                                    </TableRow>
                                  </TableHead>
                                  <TableBody>
                                    {item?.methodDefinitionsToCreate.map(
                                      (row: any) => (
                                        <TableRow
                                          sx={{
                                            "& > *": { borderBottom: "unset" },
                                          }}
                                        >
                                          <TableCell component="th" scope="row">
                                            {row.name}
                                          </TableCell>
                                          <TableCell align="center">
                                            {parseInt(
                                              row.participant?.fixedFee.amount
                                            ) > 0
                                              ? "$ " +
                                                row.participant.fixedFee
                                                  .amount +
                                                (row.participant
                                                  ?.percentageOfRateFee > 0
                                                  ? "+ " +
                                                    row.participant
                                                      ?.percentageOfRateFee +
                                                    "%"
                                                  : "")
                                              : row.participant
                                                  ?.percentageOfRateFee + "%"}
                                          </TableCell>
                                          <TableCell align="center">
                                            Calculated
                                          </TableCell>

                                          <TableCell align="right">
                                            <div>
                                              <IconButton
                                                id="basic-button"
                                                aria-controls={
                                                  open
                                                    ? "basic-menu"
                                                    : undefined
                                                }
                                                aria-haspopup="true"
                                                aria-expanded={
                                                  open ? "true" : undefined
                                                }
                                                onClick={(e) => {
                                                  handleClick(e);
                                                }}
                                              >
                                                <MoreHorizIcon />
                                              </IconButton>
                                              <Menu
                                                id="basic-menu"
                                                anchorEl={anchorEl}
                                                open={open}
                                                onClose={handleClose}
                                              >
                                                <MenuItem
                                                  onClick={() => {
                                                    handleClose();
                                                    setSelectedZone(item.name);
                                                    handleDeleteRate(row.name);
                                                  }}
                                                >
                                                  <ListItemText
                                                    sx={{ color: "red" }}
                                                  >
                                                    Delete Rate
                                                  </ListItemText>
                                                </MenuItem>
                                              </Menu>
                                            </div>
                                          </TableCell>
                                        </TableRow>
                                      )
                                    )}
                                  </TableBody>
                                </Table>
                              </TableContainer>
                            ) : (
                              <Alert severity="warning">
                                No rates. Customers in this zone won't be able
                                to complete checkout.
                              </Alert>
                            )}
                          </CardContent>
                          <CardActions>
                            <Button
                              size="small"
                              onClick={() => {
                                setOpenRate(true);
                                setSelectedZone(item.name);
                              }}
                            >
                              Add Rate
                            </Button>
                          </CardActions>
                        </Card>
                      </Box>
                    );
                  })
                ) : (
                  <Typography
                    textAlign="center"
                    gutterBottom
                    variant="h5"
                    component="div"
                  >
                    No Zone Added
                  </Typography>
                )}
              </>
            </CardContent>
          </Card>
        </>
      </Container>
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          pt: 2,
        }}
      >
        <Button onClick={handleBack} sx={{ mr: 1 }}>
          Back
        </Button>
        <Typography pt={1} color="red" textAlign="center">
          {errorMessage}
        </Typography>

        {addProfileMutationResult.isLoading ? (
          <Button
            disabled
            startIcon={<CircularProgress size="1.2rem" color="inherit" />}
          >
            Saving
          </Button>
        ) : (
          <Button onClick={handleFinish}>Finish</Button>
        )}
      </Box>
      <Dialog
        open={openZone}
        onClose={handleClose}
        aria-labelledby="draggable-dialog-title"
        fullWidth
      >
        <DialogTitle sx={{ textAlign: "center" }}>Create Zone</DialogTitle>
        <DialogContent>
          <TextField
            variant="outlined"
            name="zoneName"
            label="Zone Name"
            fullWidth
            size="small"
            sx={{ mt: 2 }}
            required
            value={zoneName}
            onChange={(e: any) => {
              setZoneName(e.target.value);
            }}
          />

          <br />
          <br />

          <TextField
            variant="outlined"
            name="countries"
            label="Search Countries"
            fullWidth
            size="small"
            required
            value={searchQuery}
            onChange={(e: any) => {
              setSearchQuery(e.target.value);
            }}
          />
          <br />
          <br />
          <div style={{ maxHeight: "350px", overflowY: "auto" }}>
            {countries
              .filter(
                (item) =>
                  item.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
                  item.provinces?.some((prov: any) =>
                    prov.name.toLowerCase().includes(searchQuery.toLowerCase())
                  )
              )
              .map((item, index) => (
                <React.Fragment key={index}>
                  <MenuItem key={item.id} value={item.id}>
                    <Checkbox
                      checked={item.isSelected}
                      onChange={() => onCountryClick(item, index)}
                      indeterminate={
                        item.isSelected &&
                        item.provinces?.some((n) => !n.isSelected)
                      }
                    />

                    <ListItemText
                      primary={item.name}
                      sx={{ paddingLeft: "10px" }}
                    />
                  </MenuItem>
                  {item.provinces
                    ?.filter((prov: any) =>
                      prov.name
                        .toLowerCase()
                        .includes(searchQuery.toLowerCase())
                    )
                    .map((province: any) => {
                      return (
                        <>
                          <MenuItem
                            key={province.id}
                            value={province.id}
                            style={{ marginLeft: 25 }}
                          >
                            <Checkbox
                              checked={province.isSelected}
                              onChange={() => {
                                onProvinceClick(province);
                              }}
                            />

                            <ListItemText primary={province.name} />
                          </MenuItem>
                        </>
                      );
                    })}
                </React.Fragment>
              ))}
          </div>
        </DialogContent>
        <DialogActions>
          <Button autoFocus onClick={handleClose}>
            Cancel
          </Button>
          <Button
            disabled={zoneName === "" ? true : false}
            onClick={handleZoneSubmit}
          >
            Apply
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={openRate}
        onClose={handleClose}
        aria-labelledby="draggable-dialog-title"
        fullWidth
      >
        <DialogTitle sx={{ textAlign: "center" }}>Add Rate</DialogTitle>
        <DialogContent>
          <FormControl sx={{ mt: 4 }} fullWidth>
            <InputLabel id="demo-simple-select-label">
              Select Carrier
            </InputLabel>
            <Select
              size="small"
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              value={carrier}
              label="Select Carrier"
              onChange={(e) => {
                handleSetCarrier(e.target.value);
              }}
            >
              {carriers.map((item) => (
                <MenuItem
                  disabled={zones
                    .find((z: any) => z.name === selectedZone)
                    ?.methodDefinitionsToCreate.some(
                      (m: any) => m.name === item.name
                    )}
                  value={item.name}
                >
                  {item.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <Divider sx={{ mt: 4 }} />
          <Typography variant="subtitle2" sx={{ mt: 3 }}>
            SERVICES
          </Typography>
          <Typography sx={{ mt: 1, fontSize: "0.8em", color: "#6d7175" }}>
            Rates are based on your customer’s address and the weight and
            dimensions of their order.
          </Typography>
          {services.length > 0
            ? services.map((service) => (
                <MenuItem key={service.service} value={service.service}>
                  <Checkbox
                    checked={service.isSelected}
                    onChange={() => onServiceClick(service.service)}
                  />
                  <ListItemText primary={service.service} />
                </MenuItem>
              ))
            : ""}
          <Divider />
          <Typography variant="subtitle2" sx={{ mt: 3 }}>
            HANDLING FEE
          </Typography>
          <Typography sx={{ mt: 1, fontSize: "0.8em", color: "#6d7175" }}>
            Adjust calculated rates to account for packaging and handling costs.
          </Typography>
          <Grid
            container
            spacing={2}
            sx={{ mt: 1.5 }}
            justifyContent="space-between"
          >
            <Grid item xs={6}>
              {" "}
              <TextField
                variant="outlined"
                name="percenatge"
                label="Percenatge"
                fullWidth
                size="small"
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">%</InputAdornment>
                  ),
                }}
                value={percentage}
                onChange={(e: any) => {
                  setPercentage(e.target.value);
                }}
              />
            </Grid>
            <Grid item xs={6}>
              {" "}
              <TextField
                variant="outlined"
                name="flatAmount"
                label="Flat Amount"
                fullWidth
                size="small"
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">$</InputAdornment>
                  ),
                }}
                value={flatAmount}
                onChange={(e: any) => {
                  setFlatAmount(e.target.value);
                }}
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button autoFocus onClick={handleClose}>
            Cancel
          </Button>
          <Button disabled={carrier === ""} onClick={handleRateSubmit}>
            Apply
          </Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
};

export default ShippingTo;
